import {
	Accordion,
	TerpenesIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../filter-header.component";
import { useFiltersContext } from "../filters.context";
import { TerpenesFilterSearch } from "./terpenes-filter-search.component";

export function TerpenesFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange, facets } = useFiltersContext();
	const value = filters.terpenes ?? [];
	const facetCounts = facets?.terpenes;

	const [searchTerm, setSearchTerm] = useState("");
	const normalizedSearch = searchTerm.trim().toLowerCase();
	const filteredTerpenes = normalizedSearch
		? config.terpenes.filter((terpene) =>
				terpene.name.toLowerCase().includes(normalizedSearch),
			)
		: config.terpenes;

	const getCount = (terpeneName: string): number | undefined => {
		if (!facetCounts?.length) return undefined;
		return facetCounts.find((f) => f.value === terpeneName)?.count ?? 0;
	};

	return (
		<Accordion.Item
			value="terpenes"
			variant="filter"
			data-testid="terpenes-filter"
		>
			<Accordion.Trigger variant="filter" data-testid="terpenes-filter-trigger">
				<FilterHeader
					title={t("filters.terpenes")}
					value={Number(value?.length)}
					icon={<TerpenesIcon size={5} />}
				/>
			</Accordion.Trigger>
			<Accordion.Content variant="filter">
				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2"
					value={value}
					onValueChange={(val) => onFilterChange("terpenes", val)}
				>
					<TerpenesFilterSearch value={searchTerm} onChange={setSearchTerm} />

					{filteredTerpenes.map((terpene) => {
						const normalizedTerpene = terpene.name
							.toLowerCase()
							.replace(/[\s_]/g, "-");
						const isSelected = value.includes(terpene.name);
						const count = getCount(terpene.name);
						const isDisabled = count === 0 && !isSelected;

						return (
							<ToggleGroup.Item
								key={terpene.name}
								value={terpene.name}
								data-testid={`terpene-${normalizedTerpene}`}
								className="capitalize"
								disabled={isDisabled}
							>
								<span
									className="mr-2 inline-block size-2 rounded-full"
									style={{ backgroundColor: terpene.color || "#000000" }}
								/>
								{terpene.name}
							</ToggleGroup.Item>
						);
					})}

					{normalizedSearch && !filteredTerpenes.length && (
						<div
							className="w-full py-2 text-left text-body-sm text-gray-500"
							data-testid="terpenes-filter-empty"
						>
							{t("filters.noTerpenesMatch")}
						</div>
					)}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
